module.exports = __webpack_public_path__ + "static/media/LogoDE.c8c4b6a8.svg";